import axiosService from './axios-service';
import {DeviceRow, InviteRequest, InviteResponse, SendInviteResponse} from '../dtos/device.dto';

class DevicesService {

    public listDevices = async (customerId: number, serviceId: number): Promise<DeviceRow[]> => {
        const result = await axiosService.get(`/api/cru/customer/${customerId}/service/${serviceId}/devices`);
        return result?.data;
    };

    public createInvite = async (customerId: number, serviceId: number, req: InviteRequest): Promise<InviteResponse> => {
        const result = await axiosService.post(`/api/cru/customer/${customerId}/service/${serviceId}/devices/invite`, req);
        return result?.data;
    };

    public editInvite = async (customerId: number, serviceId: number, inviteId: string, req: InviteRequest): Promise<InviteResponse> => {
        const result = await axiosService.put(`/api/cru/customer/${customerId}/service/${serviceId}/devices/invite/${inviteId}`, req);
        return result?.data;
    };

    public revokeInvite = async (customerId: number, serviceId: number, inviteId: string): Promise<InviteResponse> => {
        const result = await axiosService.post(`/api/cru/customer/${customerId}/service/${serviceId}/devices/invite/${inviteId}/revoke`);
        return result?.data;
    };

    public resendInvite = async (customerId: number, serviceId: number, inviteId: string): Promise<SendInviteResponse> => {
        const result = await axiosService.post(`/api/cru/customer/${customerId}/service/${serviceId}/devices/invite/${inviteId}/resend`);
        return result?.data;
    };

    public exportVpnUsage = async (customerId: number, serviceId: number, deviceId: string, windowStart: string, windowEnd: string): Promise<Blob> => {
        const result = await axiosService.get(`/api/cru/customer/${customerId}/service/${serviceId}/devices/${deviceId}/vpn-usage/export`,
            true,
            {
                responseType: 'blob',
                params: {
                    from: windowStart,
                    to: windowEnd,
                },
            }
        );
        return result?.data;
    };
}

const devicesService = new DevicesService();
export default devicesService;
